<script lang="ts" setup>   
    import {onMounted,ref} from 'vue';
    import {getScreenInfo} from '../lib/ChoiceUserConfiguration';
    import {AppScreens,PrivilegeType} from '../Enums/ChoiceEnums';
    import {DisplayStyle, IconTypes } from "../Enums/UiEnums";
    import Icon from "../components/Icon.vue"; 
    import {openWindowFromVue} from '../lib/Models/CommonItemsModel';    

    enum PrescriberBlockClass {
        Active = "prescriber-active-block rounded ",
        Inactive = "prescriber-inactive-block rounded " 
    };

    const blockClass = ref<string>();
    const prescriberIcon = ref<IconTypes>();
    const prescriberSecurityLevel = ref<boolean>(); 
    
    const props = withDefaults(defineProps<{
            prescriberID: number,
            providerID: number,
            providerFullName?: string,
            prescriberDEA?: string,
            prescriberNPI?: string,
            prescriberLocation?: string,
            prescriberAddress?: string,
            prescriberCity?: string,
            prescriberState?: string,
            prescriberZipcode?: string,
            providerAccess: number,
        }>(), { 
    }); 

    onMounted(async () => {
        blockClass.value = "prescriber-base " + (props.providerAccess === 1 ? PrescriberBlockClass.Active : PrescriberBlockClass.Inactive);
        prescriberIcon.value = (props.providerAccess === 1 ? IconTypes.Doctor : IconTypes.MedicalHouse);
        const screenJson = await getScreenInfo(AppScreens.PatientSetup); 
        prescriberSecurityLevel.value = ((screenJson?.security ?? PrivilegeType.None) > PrivilegeType.None);
    });

    function openProvider(mouseClickEvent : MouseEvent) : void {  
        const providerURL = `/officemd/screens/provider.asp?WT=Provider Setup&Qualifier=provider&WindowID=${props.providerID}`;
        openWindowFromVue("Provider", providerURL,{ noTimestamp: "Y" }); 
    }
</script>
<style scoped>
    .prescriber-base {
        color: black;
        padding: 5px;
    }
    .prescriber-inactive-block {
        background-color: #f1f1f1;
        border-top: 1pt  solid black;
        border-right: 1pt solid black;
        border-bottom: 1pt solid black;
        border-left: 1pt solid black;
    }
    .prescriber-active-block {
        background-color: #eaf2fd;
        border-top: 1pt  solid #6a8ccb;
        border-right: 1pt solid #6a8ccb;
        border-bottom: 1pt solid #6a8ccb;
        border-left: 1pt solid #6a8ccb;
    }
</style>

<template>
    <div :class="blockClass"> 
        <table style="table-layout: fixed; width: 100%;">
            <colgroup><col style="width: 60%"><col style="width: 20%"/><col style="width: 20%"/><col style="width: 25px"/></colgroup>
            <tr>
                <td colspan="3">
                    <span class="fw-bold fs-6 text-isalus-primary">Prescriber</span>
                </td>
                <td>
                    <span v-show="prescriberSecurityLevel">
                        <Icon 
                            :icon="prescriberIcon" 
                            :displayStyle="DisplayStyle.Primary" 
                            :class="'text-isalus-primary fs-5'" 
                            :title="'Open Provider'" 
                            @click="openProvider"/>                         
                    </span>
                </td>
            </tr> 
            <tr>
                <td colspan="4">
                    <span class="fw-bold label-isalus-small">{{props.providerFullName}}</span>
                </td>
            </tr>
            <tr>
                <td class="label-isalus-small">{{props.prescriberLocation}}</td>
                <td class="label-isalus-small">DEA: {{props.prescriberDEA}}</td>
                <td colspan="2" class="label-isalus-small">Provider ID: {{props.providerID}}</td>
            </tr>
            <tr>
                <td class="label-isalus-small">{{props.prescriberAddress}} {{props.prescriberCity}}, {{props.prescriberState}} {{props.prescriberZipcode}}</td>
                <td class="label-isalus-small">NPI: {{props.prescriberNPI}}</td>
                <td colspan="2" class="label-isalus-small">Prescriber ID: {{props.prescriberID}}</td>
            </tr>
        </table> 
    </div> 
</template>